'use strict';

import Admin from './admin/admin.module';
import Listados from './listados/listados.module';
import Operaciones from './operaciones/operaciones.module';
import Soporte from './soporte/soporte.module';
import Entidades from './entidades/entidades.module';

const Components = angular
  .module('app.components', [
    Admin,
    Listados,
    Soporte,
    Entidades,
    Operaciones,
  ])
  .name;

export default Components;



// WEBPACK FOOTER //
// ./src/app/components/components.js